module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "about"
  }, [_c('v-header', {
    attrs: {
      "title": _vm.title,
      "showMenuButton": false,
      "showPostButton": false,
      "showBackButton": true
    }
  }), _vm._v(" "), _vm._m(0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "about-detail"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('h1', [_vm._v("关于项目")]), _vm._v(" "), _c('p', [_vm._v("该项目基于Cnode.js的API，采用VUE全家桶重写的webapp")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('h1', [_vm._v("关于源码")]), _vm._v(" "), _c('p', [_vm._v("请点击"), _c('a', {
    attrs: {
      "href": "https://github.com/fengyinchao/v-cnode.git",
      "title": ""
    }
  }, [_vm._v("这里")]), _vm._v("查看源码")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('h1', [_vm._v("关于反馈")]), _vm._v(" "), _c('p', [_vm._v("请点击"), _c('a', {
    attrs: {
      "href": "https://github.com/fengyinchao/v-cnode/pulls",
      "title": ""
    }
  }, [_vm._v("这里")]), _vm._v("进行反馈")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('h1', [_vm._v("关于版本")]), _vm._v(" "), _c('p', [_vm._v("当前版本：V1.0")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-63136230"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/About.vue
// module id = 140
// module chunks = 1